import { Box } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';

interface DayCell {
    date: string;
    slotId?: string;
    value?: number;
    hasError?: boolean;
    history?: Array<{ userId: number; value: number; timestamp: string }>;
}

interface EditedCellRendererProps extends ICellRendererParams {
    data: Record<string, DayCell>;
    onHistoryClick?: (cellData: DayCell, event: React.MouseEvent) => void;
}

export const EditedCellRenderer = (params: EditedCellRendererProps) => {
    const colId = params.column?.getColId();
    if (!colId || !params.data) return null;

    const cellData = params.data[colId];
    const hasHistory = cellData?.history && cellData.history.length > 0;
    const value = cellData?.value;

    if (value === null || value === undefined) {
        return null;
    }

    const handleTriangleClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent cell editing
        if (params.onHistoryClick) {
            params.onHistoryClick(cellData, e);
        }
    };

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {/* CALL-796: a cell renderer bypasses the column's valueFormatter, so read its output. */}
            {params.valueFormatted}
            {hasHistory && (
                <Box
                    onClick={handleTriangleClick}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: '-3px',
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        borderWidth: '0 12px 12px 0',
                        borderColor: 'transparent #FFC107 transparent transparent',
                        cursor: 'pointer',
                        // Add clickable area
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: -4,
                            width: 16,
                            height: 16,
                        },
                    }}
                    title="Click to view edit history"
                />
            )}
        </Box>
    );
};
